import type { Dispatch, FC, SetStateAction } from 'react';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  Box,
  CloseIcon,
  Drawer,
  DrawerContent,
  DrawerHeader,
  Flex,
  Heading,
} from '@edreamsodigeo/prisma-design-system';

import InsuranceModalContentMapItinerary from './InsuranceModalContentMapItinerary';
import type { InsurancePolicy } from '@/generated/graphql';
import type { CarrierInsurancePolicy } from '@/components/FlightSummary/MapItinerary/types';

interface ConnectionInsuranceModalMapItineraryProps {
  open: boolean;
  policy: InsurancePolicy | CarrierInsurancePolicy;
  handleClose: Dispatch<SetStateAction<boolean>>;
}

const DrawerHeaderMapItinerary: FC<{
  handleClose: Dispatch<SetStateAction<boolean>>;
}> = ({ handleClose }) => {
  const { t } = useTranslation();
  return (
    <Box p="1x_small">
      <Flex justifyContent="space-between" alignItems="start">
        <Heading type="4" weight="medium">
          {t('flightsummary.itinerary.missed.connection.title')}
        </Heading>
        <CloseIcon
          color="primary.50"
          size="medium"
          onClick={(): void => handleClose(false)}
        />
      </Flex>
    </Box>
  );
};

const ConnectionInsuranceModalMapItinerary: FC<
  ConnectionInsuranceModalMapItineraryProps
> = ({ open, handleClose }) => {
  return (
    <Drawer
      open={open}
      onDismiss={(): void => handleClose(false)}
      size="large"
      fixed
    >
      <DrawerContent>
        <DrawerHeader type="Transparent">
          <DrawerHeaderMapItinerary handleClose={handleClose} />
        </DrawerHeader>
        <InsuranceModalContentMapItinerary />
      </DrawerContent>
    </Drawer>
  );
};

export default ConnectionInsuranceModalMapItinerary;
